import { useNavigate, useLocation  } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BackButton = ({ title = 'Retour', url, className = '' }) => {
    const navigate = useNavigate();  // Accès à la fonction de navigation
    const location = useLocation();  // Access to the current location
    
    const handleBack = () => {
        if (url) {
            navigate(url); // Si une URL est spécifiée, naviguer vers cette URL
        } else {
            // navigate(-1); // Sinon, retourner à la page précédente

            // Split the current path into segments
            const pathSegments = location.pathname.split('/');
            // Remove the last segment
            pathSegments.pop();
            // Join the segments back into a path
            const newPath = pathSegments.join('/') || '/';
            // Navigate to the new path
            navigate(newPath);
        }
    }

    return (
        // <div className="flex justify-center my-4">
        //     <button onClick={handleBack} className="bg-lime-500 hover:bg-lime-600 hover:shadow-md text-white font-bold py-2 px-4 rounded transition duration-150 ease-in-out">
        //         {title}
        //     </button>
        // </div>

        <button 
            onClick={handleBack} 
            className={`px-4 py-1 transition duration-150 ease-in-out z-[1001] text-[18px] ${className || 'text-white'}`}
        >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
        </button>

    )
}

export default BackButton;